var map = {
	"./alzheimer.jpg": "9899",
	"./das-neue-miteinander.jpg": "a09d",
	"./dietrich-bonhoeffer.jpg": "038a",
	"./ich-will-dich-nicht-vergessen.jpg": "7242",
	"./kinder-und-trauma.jpg": "9633",
	"./kummer-von-der-seele-schreiben.jpg": "78eb",
	"./mobbing-bei-kindern.jpg": "82fa",
	"./reden-ist-gold.jpg": "a96c",
	"./so-will-ich-leben.jpg": "8e97",
	"./trauma.jpg": "bf75",
	"./wenn-die-familie-zerbricht.jpg": "b439",
	"./wenn-trauma-und-trauer-aufeinandertreffen.jpg": "376a",
	"./wohnst-du-jetzt-im-himmel.jpg": "a22a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "340f";